import type { AutomationStepContentMode, AutomationStepRow } from './types';

export type { AutomationStepContentMode };

export const CONTENT_MODE_OPTIONS: Array<{
  value: AutomationStepContentMode;
  label: string;
  description: string;
}> = [
  {
    value: 'manual',
    label: 'Manual',
    description:
      'Send subject and HTML directly. Use {{first_name}}, {{name}}, or {{email}} — filled per subscriber at send time.',
  },
  {
    value: 'template_wrap',
    label: 'Wrapper template',
    description:
      'Postmark layout wraps your HTML. Use {{first_name}}, {{name}}, {{email}}, or {{scheduled_email_id}} (footer) in the template — filled per send.',
  },
  {
    value: 'template_only',
    label: 'Template only',
    description:
      'All copy lives in the Postmark template. Merge vars include {{scheduled_email_id}} per send row.',
  },
];

export function inferContentMode(
  step: Pick<AutomationStepRow, 'content_mode' | 'postmark_template_alias' | 'body_html'>,
): AutomationStepContentMode {
  if (step.content_mode === 'manual' || step.content_mode === 'template_wrap' || step.content_mode === 'template_only') {
    return step.content_mode;
  }
  const alias = (step.postmark_template_alias ?? '').trim();
  if (!alias) return 'manual';
  if ((step.body_html ?? '').trim()) return 'template_wrap';
  return 'template_only';
}

export function contentModeBadgeLabel(mode: AutomationStepContentMode): string {
  switch (mode) {
    case 'manual':
      return 'Manual';
    case 'template_wrap':
      return 'Wrapper';
    case 'template_only':
      return 'Template';
  }
}

export function contentModeBadgeClass(mode: AutomationStepContentMode): string {
  switch (mode) {
    case 'manual':
      return 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200 border-gray-200 dark:border-gray-600';
    case 'template_wrap':
      return 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-200 border-blue-200 dark:border-blue-800';
    case 'template_only':
      return 'bg-violet-50 text-violet-700 dark:bg-violet-900/30 dark:text-violet-200 border-violet-200 dark:border-violet-800';
  }
}
